import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '../button/button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizePipe } from '../../../i18n/pipes/lozalize.pipe';

@Component({
    selector: 'app-our-showroom',
    templateUrl: './our-showroom.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, TranslatePipe, LocalizePipe],
})
export class OurShowroomComponent {
    private router = inject(Router);

    @Input()
    titleStyle = 'primary';

    navigateTo(url: string): void {
        void this.router.navigate([url]);
    }
}
